import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedSuperAdminRoute({ children, userType }) {
  if (userType !== "super_admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedSuperAdminRoute;
